import React, { useState } from 'react';
import useTranslation from 'Hooks/useTranslation';
import { CircularProgress } from '@mui/material';
import useCertificate from './Hooks/useCertificate';
import useDateFormatter from './Hooks/useDateFormatter';
import CertificateContent from './Components/CertificateContent';
import { Container, Content } from './style';

const Certification = ({ course }) => {
  const { t2 } = useTranslation('CourseDetails');
  const [isLoading, setIsLoading] = useState(true);
  const { userName, certification } = useCertificate(course[10], setIsLoading);
  const { formatExpirationDate } = useDateFormatter(t2);

  const expirationDateString = formatExpirationDate(certification?.expirationDate);

  if (isLoading) {
    return (
      <Container>
        <Content>
          <CircularProgress color="success" aria-label="Cargando certificado" />
        </Content>
      </Container>
    );
  }

  return (
    <Container>
      <CertificateContent
        certification={certification}
        userName={userName}
        course={course}
        t2={t2}
        expirationDateString={expirationDateString}
      />
    </Container>
  );
};

export default Certification;
